export function getScoreColor(score) {
  if (score >= 90) return 'text-green-500';
  if (score >= 80) return 'text-emerald-500';
  if (score >= 70) return 'text-bastion-blue-500';
  if (score >= 60) return 'text-yellow-500';
  if (score >= 50) return 'text-orange-500';
  return 'text-red-500';
}

export function getScoreBgColor(score) {
  if (score >= 90) return 'bg-green-500';
  if (score >= 80) return 'bg-emerald-500';
  if (score >= 70) return 'bg-bastion-blue-500';
  if (score >= 60) return 'bg-yellow-500';
  if (score >= 50) return 'bg-orange-500';
  return 'bg-red-500';
}

export function getScoreLabel(score) {
  if (score >= 90) return 'Excellent';
  if (score >= 80) return 'Great';
  if (score >= 70) return 'Good';
  if (score >= 60) return 'Fair';
  if (score >= 50) return 'Needs Work';
  return 'Keep Practicing';
}

export function formatDimensionName(key) {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, s => s.toUpperCase())
    .trim();
}

export function getScoreRingColor(score) {
  if (score >= 90) return '#22c55e';
  if (score >= 80) return '#10b981';
  if (score >= 70) return '#2383E2';
  if (score >= 60) return '#eab308';
  if (score >= 50) return '#f97316';
  return '#ef4444';
}
